const SOCIALS = ["VIMEO", "IMDB", "LINKEDIN", "ARTSTATION", "INSTAGRAM"];

export const Footer = () => (
  <footer id="footer" data-testid="footer-section" className="relative pt-24 pb-10 px-4 sm:px-8 lg:px-16 overflow-hidden border-t border-white/10">
    <div className="absolute inset-0 lens-flare pointer-events-none" />
    <div className="max-w-7xl mx-auto relative">
      <h2 className="font-display text-[16vw] lg:text-[11rem] leading-none tracking-wide text-center">
        <span className="text-zinc-50">LET'S FAKE</span> <span className="text-stroke">IT.</span>
      </h2>
      <div className="mt-16 flex flex-col sm:flex-row items-center justify-between gap-8 border-t border-white/10 pt-10">
        <div className="flex items-center gap-3">
          <img src="/kth-logo.png" alt="KTH Studios — Kingdom of Theatrical Horizon" className="h-14 w-auto" />
        </div>
        <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-3">
          {SOCIALS.map((s) => (
            <a key={s} data-testid={`footer-social-${s.toLowerCase()}`} href="#footer" onClick={(e) => e.preventDefault()}
              className="font-mono2 text-[11px] tracking-[0.3em] text-zinc-500 hover:text-amber-500 transition-colors">{s}</a>
          ))}
          <a href="/admin" data-testid="footer-admin-login-link"
            className="font-mono2 text-[11px] tracking-[0.3em] text-amber-500/80 hover:text-amber-400 transition-colors">STUDIO LOGIN</a>
        </div>
        <p className="font-mono2 text-[10px] tracking-[0.2em] text-zinc-600">© 2026 KINGDOM OF THEATRICAL HORIZON. ALL REALITIES RESERVED.</p>
      </div>
    </div>
  </footer>
);
